export default __webpack_public_path__ + "static/media/torbjorn-turret.08913351.mp3";